import AppRouter from "./routes";
import usePiPRedirect from "./context/usePiPRedirect";
import { useVersionCheck } from "./hooks/useVersionCheck";
import useGlobalContext from "./context/useGlobalContext";

function App() {
  const { featureMap } = useGlobalContext();
  const isAutoRefreshEnabledAfterDeployement = featureMap?.auto_refresh_after_deployment ?? false;
  usePiPRedirect();
  useVersionCheck(isAutoRefreshEnabledAfterDeployement);
  return (
    <div className="app" style={{ position: "relative", height: "100%" }}>
      <AppRouter />
    </div>
  );
}

export default App;
